module.exports = __webpack_public_path__ + "fonts/tianhong.e548cbf6.woff";